import React, { useState } from "react";
import styled from "styled-components";

import SafeLink from "components/commons/SafeLink";
import { WealthyEnv } from "helpers";

const linkedinImage = `${WealthyEnv.HOMEPAGE_CDN_URL}/founder-card-linkedIn-about-us.svg`;

const TeamMember = ({ image, name, position, education, experience, linkedin, showBullets, bulletCount, bulletIndex }) => (
  <MemberCard>
    <Avatar
      src={image}
      alt={name}
      width={150}
      height={150}
      sizes="11rem"
      loading="lazy"
      decoding="async"
    />
    <Name>{name}</Name>
    <Position>{position}</Position>
    <Education>{education}</Education>
    <Experience>{experience}</Experience>
    {linkedin && (
      <LinkedIn href={linkedin} target="_blank" rel="noopener noreferrer">
        <LinkedInIcon
          src= {linkedinImage}
          alt="LinkedIn Icon"
          width={24}
          height={24}
          decoding="async"
        />
      </LinkedIn>
    )}
  </MemberCard>
);

const MemberCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    width: 40rem;
    flex: 0 0 auto;
    margin-bottom: 0;
    background: #fff;
    border-radius: 12px;
    padding: 16px 8px;
    margin: 0 8px;
  }
`;

const Avatar = styled.img`
  width: 11rem;
  height: 11rem;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 1.6rem;
`;

const Name = styled.h3`
  font-size: 3rem;
  color: #1C1C1C;
  font-family: 'Lato';
  font-weight: 700;
  margin: 0 0 4px 0;

  @media (max-width: 768px) {
    font-size:1.8rem
  }
`;

const Position = styled.div`
  font-size: 2rem;
  font-family: 'Lato';
  font-weight: 400;
  color: #1D1D1F;
  margin-bottom: 4px;

  @media (max-width: 600px) {
    font-size:1.4rem
  }
`;

const Education = styled.div`
  font-size: 1.6rem;
  font-family: 'Lato';
  font-weight: 400;
  color: #6F6F6F;
  margin-bottom: 2px;

  @media (max-width: 768px) {
    font-size:1.4rem
  }
`;

const Experience = styled.div`
  font-size: 1.6rem;
  font-weight: 400;
  color: #6F6F6F;
  margin-bottom: 8px;
  font-family: 'Lato';
  @media (max-width: 768px) {
    font-size:1.4rem
  }
`;

const LinkedIn = styled(SafeLink)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: inherit;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 0.8;
  }
`;

const LinkedInIcon = styled.img`
  width: 24px;
  height: 24px;
  object-fit: contain;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 0.8;
  }
`;


export default TeamMember;